import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { FailedMessagesEndpoint } from '../../constants/failed-messages-endpoint';
import { FailedMessagesReportFieldModel } from '../../models/profile/failed-messages-profile-report.model';

@Injectable({
  providedIn: 'root',
})
export class FailedMessagesProfileReportService {
  constructor(private http: WrapperHttpService) {}

  getReport(): Observable<FailedMessagesReportFieldModel[]> {
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Profiles}${FailedMessagesEndpoint.Report}${FailedMessagesEndpoint.Fields}`;
    return this.http.withLoading().get<FailedMessagesReportFieldModel[]>(url);
  }
}
